module.exports = __webpack_public_path__ + "img/bg-department.a5db0f0d.png";